import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import cx from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, A11y, Keyboard, Thumbs } from "swiper";
import { getStoryblokImageServiceUrl } from "@cinch-nx/data-storyblok";
import { ChevronLeftIcon, ChevronRightIcon } from "@cinch-nx/design-system-icons";
import styles from "./car-review-gallery.module.css";
import { useViewport } from "@cinch-labs/shared-util";
SwiperCore.use([
    Navigation,
    Pagination,
    A11y,
    Keyboard,
    Thumbs
]);
export var CarReviewGallery = function(param) {
    var _images = param.images, images = _images === void 0 ? [] : _images, updateGalleryPaginationNumber = param.updateGalleryPaginationNumber, imageIndex = param.imageIndex;
    var ref = useState(), thumbsSwiper = ref[0], setThumbsSwiper = ref[1];
    var mainSwiper = useRef(null);
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    useEffect(function() {
        console.log({
            imageIndex: imageIndex
        });
    }, [
        imageIndex
    ]);
    var isDesktop = vw >= 1024;
    var slides = generateSlides(images, []);
    var thumbs = generateThumbs(images, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("button", {
                className: cx(styles.btn, styles.nextBtn),
                onClick: function() {
                    if (mainSwiper.current) {
                        mainSwiper.current.slideNext();
                    }
                },
                "aria-label": "Next slide",
                children: /*#__PURE__*/ _jsx(ChevronRightIcon, {
                    size: 24
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                className: cx(styles.btn, styles.prevBtn),
                onClick: function() {
                    if (mainSwiper.current) {
                        mainSwiper.current.slidePrev();
                    }
                },
                "aria-label": "Previous slide",
                children: /*#__PURE__*/ _jsx(ChevronLeftIcon, {
                    size: 24
                })
            }),
            /*#__PURE__*/ _jsx(Swiper, {
                keyboard: true,
                loop: true,
                slidesPerView: 1,
                initialSlide: imageIndex || 0,
                className: styles.featured,
                thumbs: {
                    swiper: thumbsSwiper,
                    slideThumbActiveClass: styles.activeThumbnail
                },
                onSwiper: function(swiper) {
                    return mainSwiper.current = swiper;
                },
                onSlideChange: function(swiper) {
                    var slideChangeDetails = {
                        direction: swiper.touches.diff < 0 ? "right" : "left",
                        activeIndex: swiper.realIndex + 1
                    };
                    updateGalleryPaginationNumber(slideChangeDetails);
                },
                children: slides
            }),
            /*#__PURE__*/ _jsx(Swiper, {
                onSwiper: function(swiper) {
                    setThumbsSwiper(swiper);
                },
                className: styles.thumbnails,
                slidesPerView: isDesktop ? 4.5 : 3.5,
                spaceBetween: 10,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                children: thumbs
            })
        ]
    });
};
export function generateSlides(images, classNames) {
    var ref;
    return images.map(function(image, idx) {
        /*#__PURE__*/ return _jsx(SwiperSlide, {
            className: cx.apply(void 0, [
                styles.slide
            ].concat(_to_consumable_array(classNames))),
            children: /*#__PURE__*/ _jsxs("figure", {
                className: image.title ? styles.hasCaption : undefined,
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: getStoryblokImageServiceUrl(image.filename, {
                            width: 800,
                            filters: [
                                {
                                    quality: 80
                                },
                                {
                                    fill: "transparent"
                                }
                            ],
                            fitIn: {
                                width: 800,
                                height: 600
                            }
                        }),
                        alt: (ref = image === null || image === void 0 ? void 0 : image.alt) !== null && ref !== void 0 ? ref : "No Alt-Text provided."
                    }),
                    image.title && /*#__PURE__*/ _jsx("figcaption", {
                        className: styles.slideFigcaption,
                        children: image.title
                    })
                ]
            })
        }, "".concat(image.id, "-").concat(idx));
    });
}
export function generateThumbs(images, classNames) {
    return images.map(function(image, idx) {
        return /*#__PURE__*/ _jsx(SwiperSlide, {
            className: cx.apply(void 0, [
                styles.thumbnailSlide
            ].concat(_to_consumable_array(classNames))),
            children: /*#__PURE__*/ _jsx("img", {
                src: getStoryblokImageServiceUrl(image.filename, {
                    filters: [
                        {
                            quality: 40
                        },
                        {
                            fill: "transparent"
                        }
                    ],
                    fitIn: {
                        width: 220,
                        height: 165
                    }
                }),
                alt: "Thumbnail for slide #".concat(idx + 1)
            })
        }, "".concat(image.id, "-").concat(idx, "-thumb"));
    });
}
